import {Constants} from "../../constants";
import {CatalogComponent} from "./catalog.component";
import {Routes} from "@angular/router";
import {UserRolesGuard} from "../../route-guards/user-roles.guard";

export const CATALOG_ROUTES: Routes = [
    {
        path: ':locale',
        canActivateChild: [UserRolesGuard],
        children: [
            {
                path: Constants.CATALOG_STATE + '/:categoryId',
                component: CatalogComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    restrict: [Constants.ROLES.NFR_MHP_ONLY],
                    restrictGroup: [[Constants.ROLES.CBEC, Constants.ROLES.RETAIL]]
                }
            },
            {
                path: Constants.TAG_CATALOG_STATE + '/:tagId',
                component: CatalogComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    restrict: [Constants.ROLES.NFR_MHP_ONLY],
                    restrictGroup: [[Constants.ROLES.CBEC, Constants.ROLES.RETAIL]]
                }
            }
        ]
    }
];
